import FixedList from './src/fixedlist.vue';

FixedList.install = function (Vue) {
    Vue.component(FixedList.name, FixedList);
};

export default FixedList;